module.exports = __webpack_public_path__ + "img/logo1.8f19e279.png";